"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Flex = ({ dataCy, children, direction, wrap, align, justify, customClass, style }) => {
    const flexClasses = (0, classnames_template_literals_1.default)(`
    flex
    flex-${direction}
    flex-${wrap}
    items-${align}
    justify-${justify}
    ${customClass}
  `);
    return (react_1.default.createElement("div", { className: flexClasses, "data-cy": dataCy, style: style }, children));
};
Flex.defaultProps = {
    dataCy: '',
    direction: 'row',
    wrap: 'nowrap',
    align: 'stretch',
    justify: 'start'
};
exports.default = Flex;
